import { Box, Typography } from '@mui/material';
import { v4 } from '@rotra-air-ocean/rotranext-shared-code';

import { KIND_META, KindIcon } from '$layouts/v2/consts.jsx';

import { KIND_ORDER } from './constants';

export function KindPicker({
  value,
  onChange,
}: {
  value: v4.StepKind;
  onChange: (k: v4.StepKind) => void;
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 1,
      }}
    >
      {KIND_ORDER.map((k) => {
        const m = KIND_META[k];
        const active = k === value;
        return (
          <Box
            key={k}
            component="button"
            type="button"
            onClick={() => onChange(k)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5,
              p: 1,
              cursor: 'pointer',
              borderRadius: 1,
              border: '2px solid',
              borderColor: active ? m.color : 'divider',
              bgcolor: active ? `${m.color}14` : 'background.paper',
              color: active ? m.color : 'text.primary',
            }}
          >
            <KindIcon kind={k} size={18} />
            <Typography variant="caption">{m.label}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}
